import { combineReducers } from 'redux';

import { authentication } from './AuthReducer';
import { vendor } from './VendorReducer';
import { alert } from './AlertReducer';
import { validationErrors } from './ErrorReducer';
import { donationCheckout, checkoutProcessing, checkoutPaymentRefs, googleApplePaymentId } from './CheckouFormReducer';
import {
  fundraiser_page, campaigns, occasions, currencies, countries, validate_fd_page_title,
  get_users_except_lead, team_members_list_by_user, get_teams_fund_stat,
  get_all_team_members, get_all_fundraiser_page_donors, past_fundraiser_page, get_event_id, get_active_team_members, add_updates_as_description_or_images,
  get_all_fundraiser_page_mostrecent_donations, get_all_fundraiser_page_most_donations,
  get_all_team_members_with_pagination
} from './FundraiserReducer';
import {
  donation, donation_rebates, donations_by_user, latest_donations_by_user, donations_paginate_by_user,
  hbl_config_data, payment_methods, banks_list, user_profile_details, updateDonationDetails, currencyDefaultAmountOptions, check_if_country_has_giftaid,
  check_if_country_partner_isactive_for_fundraiser, check_if_country_partner_isactive_for_donor, isCountryCorporateMatch
} from './DonationReducer';

import { profile } from './ProfileReducer';


const rootReducer = combineReducers({
  authentication,
  vendor,
  alert,
  validationErrors,
  fundraiser_page,
  campaigns,
  occasions,
  currencies,
  countries,
  validate_fd_page_title,
  donation,
  donation_rebates,
  get_users_except_lead,
  get_all_team_members,
  get_all_fundraiser_page_donors,
  donations_by_user,
  latest_donations_by_user,
  donations_paginate_by_user,
  team_members_list_by_user,
  get_teams_fund_stat,
  past_fundraiser_page,
  hbl_config_data,
  payment_methods,
  banks_list,
  user_profile_details,
  get_event_id,
  get_active_team_members,
  updateDonationDetails,
  add_updates_as_description_or_images,
  get_all_fundraiser_page_mostrecent_donations,
  get_all_fundraiser_page_most_donations,
  get_all_team_members_with_pagination,
  profile,
  currencyDefaultAmountOptions,
  check_if_country_has_giftaid,
  check_if_country_partner_isactive_for_fundraiser,
  check_if_country_partner_isactive_for_donor,
  isCountryCorporateMatch,
  donationCheckout,
  checkoutProcessing,
  checkoutPaymentRefs,
  googleApplePaymentId,
});

export default rootReducer;
